import Modal from "../../../Components/Modal/Modal";
import SmallCard from "../../../Components/SmallCard/SmallCard";
import requestIcon from "../../../icons/requestIcon.svg"
import checkEmpty from "../../../images/Check_Empty.svg"
import check from "../../../images/Check.svg"
export default function RequestAssignment({ isOpen, setOpen, requestFile, request, setRequest, onSave }) {
    const selectParticipant = (id) => {
        const newState = request?.Participants.map((x) => {
            if (x.Id == id) {
                return { ...x, isActive: true }
            }
            return x;
        }
        )
        setRequest({ ...request, Participants: newState });
    }
    return (<Modal onSave={onSave} title="Назначить заявление" isOpen={isOpen} setOpen={setOpen}>
        <label>Заявление</label>
        <SmallCard avatar={requestIcon} title={requestFile?.FileName} subtitle={requestFile?.DocType.name}></SmallCard>
        <label>Подписанты</label>
        {request?.Participants.map((x) => {
            const title = x.FlSubject ? x.FlSubject.name : x.UlAgent.name;
            return (
                <SmallCard title={title} onSelect={() => selectParticipant(x.Id)} type={x.isActive ? "primary" : "default"} avatar={x.isActive ? check : checkEmpty}></SmallCard>
            )
        }
        )}
    </Modal>)
}